import React from 'react';
import { siteData } from '../data/mock';

const Home = () => {
  const { home } = siteData;
  
  return (
    <article className="space-y-14 sm:space-y-20">
      {/* Hero */}
      <header className="space-y-5 sm:space-y-6">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-light text-[#1a1a1a] leading-snug sm:leading-tight tracking-tight">
          {home.headline}
        </h1>
        <p className="text-base sm:text-lg text-[#4a4a4a] leading-relaxed">
          {home.tagline}
        </p>
        <p className="text-sm sm:text-base text-[#666666] leading-relaxed">
          {home.supportingLine}
        </p>
      </header>
      
      {/* What Business-Catalysts Does */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.positioning.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {home.positioning.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Enterprise Modernization in the AI Era */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.modernization.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {home.modernization.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <div className="space-y-1 text-[#2a2a2a] text-base leading-relaxed pt-3 sm:pt-4">
          {home.modernization.micro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Commercial Architecture Section */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.commercialArchitecture.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {home.commercialArchitecture.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        
        {/* The Commercial Architecture Layer */}
        <div className="pt-4 sm:pt-6 space-y-5 sm:space-y-6">
          <h3 className="text-[#1a1a1a] text-base font-medium">
            {home.commercialArchitecture.subheading}
          </h3>
          <p className="text-[#2a2a2a] text-base leading-relaxed">
            {home.commercialArchitecture.subheadingIntro}
          </p>
          
          {/* Four Architecture Domains */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 pt-2">
            {home.commercialArchitecture.domains.map((domain, i) => (
              <div key={i} className="space-y-2">
                <h4 className="text-[#1a1a1a] text-base font-medium">
                  {domain.title}
                </h4>
                <p className="text-[#2a2a2a] text-base leading-relaxed">
                  {domain.description}
                </p>
              </div>
            ))}
          </div>
          
          {/* Closing */}
          <div className="space-y-1 text-[#2a2a2a] text-base leading-relaxed pt-4 sm:pt-6">
            {home.commercialArchitecture.closing.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </section>
      
      {/* The Context */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.context.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {home.context.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Our Role */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.role.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {home.role.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Our Philosophy */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.philosophy.title}
        </h2>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {home.philosophy.points.map((point, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">—</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
        <p className="text-[#2a2a2a] text-base leading-relaxed pt-3 sm:pt-4">
          {home.philosophy.closing}
        </p>
      </section>
      
      {/* How We Think About Execution */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {home.execution.title}
        </h2>
        <p className="text-[#2a2a2a] text-base leading-relaxed">
          {home.execution.intro}
        </p>
        <p className="text-[#2a2a2a] text-base leading-relaxed">
          {home.execution.connectsLabel}
        </p>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {home.execution.connects.map((item, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">—</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed pt-3 sm:pt-4">
          {home.execution.closing.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
    </article>
  );
};

export default Home;
